import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'

import Typography from '@material-ui/core/Typography'
import Input from 'components/shared/Input'

interface IProps {
  handleForgotPassword: (username: string) => void
  login: () => void
  error: string
}

interface IState {
  username: string
}

class ForgotPasswordScreen extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)
    this.state = {
      username: '',
    }
  }

  private _handleUsernameChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      ...this.state,
      username: evt.currentTarget.value,
    })
  }

  private handleSubmit = async (event): Promise<void> => {
    event.preventDefault()
    this.props.handleForgotPassword(this.state.username)
  }

  public render(): JSX.Element {
    const { username } = this.state
    const { login } = this.props

    return (
      <form name="forgot" onSubmit={this.handleSubmit}>
        <Grid container direction="column" spacing={3} style={{ backgroundColor: '#fff' }}>
          <Box p={5}>
            <Grid item>
              <Input label="Email" value={username} onChange={this._handleUsernameChange} />
            </Grid>
            <Grid item>
              <Box mt={{ xs: 2, md: 5 }}>
                <Button fullWidth variant="contained" type="submit">
                  <Typography variant="h4" color="primary">
                    Submit
                  </Typography>
                </Button>
              </Box>
            </Grid>
            <Grid container item justify="center">
              <Typography variant="h4" color="secondary" onClick={login}>
                <Box mt={{ xs: 2, md: 5 }}>Log in</Box>
              </Typography>
            </Grid>
          </Box>
        </Grid>
      </form>
    )
  }
}

export default ForgotPasswordScreen
